<div class="sm:hidden min-h-screen">
  <header
    class="border-b border-gray-200 bg-blue text-white p-4 pb-14 w-full h-full"
  >
    <h1 class="text-3xl font-semibold mb-1 md:text-4xl">Get e-Coupon</h1>
    <p class="text-xs md:text-sm">
      Free e-Coupon Starbucks 100 THB when you tap to pay with Visa card 500 THB
      or more (participating stores only)
    </p>
  </header>
  <div class="mt-[-40px] px-4">
    <router-outlet></router-outlet>
  </div>
</div>
<div
  class="max-sm:hidden text-center flex items-center justify-center h-screen"
>
  <div>This application allow to use on mobile only</div>
</div>
